var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNr = function SvgIconNr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0052B4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.001 0C5.725 0 .576 4.817.047 10.956h23.909C23.426 4.817 18.277 0 12 0M12 24c6.276 0 11.426-4.818 11.955-10.956H.044C.576 19.182 5.726 24 12 24"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m9.914 16.175-1.345.632.716 1.302-1.46-.279-.185 1.475-1.017-1.085-1.017 1.085-.185-1.475-1.46.28.716-1.303-1.345-.632 1.345-.633-.716-1.302 1.46.28.185-1.476 1.017 1.085 1.017-1.085.185 1.475 1.46-.28-.716 1.303z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconNr;